"use client";
import React, { useState } from "react";
import BlogCard from "@/components/Cards/BlogCard";

export default function GuidesClient({ data }) {
  const [sortOrder, setSortOrder] = useState("");

  const handleSortChange = (e) => {
    setSortOrder(e.target.value);
  };

  const sortedGuides = [...data.guidesConnection.edges].sort((a, b) => {
    const dateA = new Date(a.node.updatedAt).getTime();
    const dateB = new Date(b.node.updatedAt).getTime();

    if (sortOrder === "newest") {
      return dateB - dateA;
    } else {
      return dateA - dateB;
    }
  });

  return (
    <>
      <div className="">
        {/* all guides */}
        <div className="my-14 space-y-6">
          <div className="flex items-center justify-between w-full">
            <h2 className="text-3xl font-bold text-gray-900">
              {data.guidesConnection.edges.length} Available Guides
            </h2>

            <div className="w-full lg:w-[20%] flex items-center space-x-2">
              <p className="text-sm font-medium text-gray-700">Sort by:</p>
              <div className="p-1 border bg-transparent rounded-lg">
                <select
                  className="p-1 bg-transparent outline-none"
                  onChange={handleSortChange}
                  value={sortOrder}
                >
                  {" "}
                  <option value="">Select</option>
                  <option value="newest">Newest</option>
                </select>
              </div>
            </div>
          </div>

          <div className="gap-4 w-full h-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
            {sortedGuides.map((item) => (
              <BlogCard
                key={item.node.id}
                title={item?.node?.headingOne}
                excerpt={item?.node?.metaDescription}
                date={item.node.updatedAt.slice(0, 10)}
                link={item.node.slug}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
